// extracted by css-extract-rspack-plugin
export default {"root":"root-hjPWI3 flex","content":"content-DNt8oN","schedule":"schedule-hivFaO","phoneNumber":"phoneNumber-cxtjUZ text-interactive-link"};